import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { MatTab, MatTabGroup } from '@angular/material/tabs'
import { TableListTariffSelectComponent } from '../../../shared/components/table-list-tariff-select/table-list-tariff-select.component'
import { convertCurrency } from '../../../shared/utils/utils'

@Component({
  selector: 'modal-tariff-proposal',
  imports: [
    MatProgressBar,
    PaginationComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatButton,
    MatTab,
    MatTabGroup,
    TableListTariffSelectComponent,
  ],
  templateUrl: './modal-tariff-proposal.component.html',
  styleUrl: './modal-tariff-proposal.component.scss',
  standalone: true,
  providers: [LegalEntityClientService],
})
export class ModalTariffProposalComponent implements OnInit {
  constructor(
    private tariffService: TariffService,
    private dialogRef: MatDialogRef<ModalTariffProposalComponent>,
    private snackbar: SnackbarCustomService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.idClient) {
      this.idClient = data.idClient
    }
    this.multiSelect = data.multiSelect ?? false
    if (this.multiSelect) {
      this.listSelected = data.item
    } else {
      this.selected = data.item
    }
  }

  idClient = -1
  multiSelect = false

  @Output() responseSingle = new EventEmitter()
  @Output() responseMulti = new EventEmitter()

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch = ''

  pageClient = 1
  rowsClient = 10
  numberRowsClient = 0
  itemsListClient: any[] = []
  loadingClient = false
  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'location_OD',
      key: 'origem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'cost',
      key: 'custo_formatado',
      description: 'Custo',
    },
    {
      keyColumn: 'custoExtra_HK',
      key: 'custo_formatado',
      description: 'Custo Extra',
    },
    {
      keyColumn: 'validity',
      key: 'dataValidade',
      description: 'validade',
    },
  ]

  pageTgmob = 1
  rowsTgmob = 10
  numberRowsTgmob = 0
  itemsListTgmob: any[] = []
  loadingTgmob = false

  ngOnInit() {
    this.getListItems()
    if (this.idClient) {
      this.getListItemsClient()
    }
  }

  close() {
    this.dialogRef.close()
  }

  search(event: any) {
    const search = event
    this.pageTgmob = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number, type: 'tgmob' | 'client') {
    if (type == 'tgmob') {
      this.pageTgmob = page
      this.uploadListTgmob()
    } else if (type == 'client') {
      this.pageClient = page
      this.uploadListClient()
    }
  }

  uploadListTgmob(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  uploadListClient(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItemsClient()
    }
  }

  treatResponseTgmob(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          custo_formatado: `R$ ${convertCurrency(item.custo)}`,
          custoHoraExtra_formatado: `R$ ${convertCurrency(item.custoHoraExtra)}`,
          custokmExtra_formatado: `R$ ${convertCurrency(item.custokmExtra)}`,
        })
      }
    }
    this.itemsListTgmob = list
    this.numberRowsTgmob = response.totalItens
  }

  treatResponseClient(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          custo_formatado: `R$ ${convertCurrency(item.custo)}`,
          custoHoraExtra_formatado: `R$ ${convertCurrency(item.custoHoraExtra)}`,
          custokmExtra_formatado: `R$ ${convertCurrency(item.custokmExtra)}`,
        })
      }
    }
    this.itemsListClient = list
    this.numberRowsClient = response.totalItens
  }

  getListItems() {
    this.loadingClient = true
    this.tariffService
      .listPagedTariff(this.pageClient, this.rowsClient)
      .subscribe({
        next: (response: any) => {
          this.treatResponseTgmob(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loadingClient = false
        },
      })
  }

  getListItemsClient() {
    this.loadingTgmob = true
    this.tariffService
      .listPagedTariffClientbyId(this.pageTgmob, this.rowsTgmob, this.idClient)
      .subscribe({
        next: (response: any) => {
          this.treatResponseClient(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loadingTgmob = false
        },
      })
  }

  searchListItems() {
    this.loadingTgmob = true
    this.tariffService
      .searchPagedTariff(this.pageTgmob, this.rowsTgmob, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponseTgmob(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loadingTgmob = false
        },
      })
  }

  selectItem(event: any) {
    if (this.multiSelect) {
      const index = this.listSelected.findIndex((ele) => ele.id == event.id)
      if (index > -1) {
        this.listSelected.splice(index, 1)
      } else {
        this.listSelected.push(event)
      }
    } else {
      if (this.selected.id == event.id) {
        this.selected = { id: -1, description: '' }
      } else {
        this.selected = event
      }
    }
  }

  checkForm() {
    if (this.selected.id || this.listSelected.length > 0) {
      return true
    } else {
      return false
    }
  }

  removeSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: true })
    } else {
      this.responseSingle.emit({ remove: true })
    }
    this.close()
  }

  confirmSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: false, selection: this.listSelected })
    } else {
      this.responseSingle.emit({ remove: false, selection: this.selected })
    }
    this.close()
  }

  editItem(event: any) {
  }

  deleteItem(event: any) {
  }
}
